import { render, staticRenderFns } from "./InfoTable.vue?vue&type=template&id=4d039afc&scoped=true&"
import script from "./InfoTable.vue?vue&type=script&lang=js&"
export * from "./InfoTable.vue?vue&type=script&lang=js&"
import style0 from "./InfoTable.vue?vue&type=style&index=0&id=4d039afc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d039afc",
  null
  
)

export default component.exports